import { useEffect } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { esAnalyticsPath } from './EsAnalytics';
import { esRumRoute } from './EsRum';

/**
 * Names each route for New Relic by its scrubbed path, so a campaign id or a pack
 * key never becomes a page name. Renders nothing, and does nothing until
 * EsRumAgent has started an agent.
 */
export default function EsRumRoute() {
    const { pathname } = useLocation();
    const aPath = esAnalyticsPath( pathname, useParams() );

    useEffect( () => {
        esRumRoute( aPath );
    }, [ aPath ] );

    return null;
}
